import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { applyTheme, applyBranding } from "@/lib/color";

const BrandingContext = createContext(null);

const DEFAULT_BRANDING = {
  company_name: "ASTRAL Saúde Ambiental",
  system_name: "Control Intelligence",
  login_name: "ASTRAL",
  header_name: "ASTRAL Saúde Ambiental",
  browser_title: "ASTRAL Saúde Ambiental • Control Intelligence",
  favicon: "", logo_main: "", logo_small: "", logo_light: "", logo_dark: "",
  logo_pdf: "", logo_pwa: "", login_bg: "",
  login_message: "Gestão inteligente de saúde ambiental e controle de pragas.",
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [activeTheme, setActiveTheme] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/themes/public`);
      setBranding({ ...DEFAULT_BRANDING, ...data.branding });
      setActiveTheme(data.theme);
      applyTheme(data.theme);
      applyBranding(data.branding);
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const preview = (theme) => applyTheme(theme, "astral-theme-preview");
  const clearPreview = () => applyTheme(null, "astral-theme-preview");
  // Tema individual do usuário (não afeta os demais usuários nem a identidade global)
  const applyUserTheme = (theme) => applyTheme(theme, "astral-theme-user");
  const clearUserTheme = () => applyTheme(null, "astral-theme-user");

  return (
    <BrandingContext.Provider value={{ branding, activeTheme, refresh, preview, clearPreview, applyUserTheme, clearUserTheme }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
